import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=623335db&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623335db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('623335db')) {
      api.createRecord('623335db', component.options)
    } else {
      api.reload('623335db', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=623335db&scoped=true&", function () {
      api.rerender('623335db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FWueGFO6DSPu/JS/comp/Voucher-Unit.vue"
export default component.exports